/**
 * 路由工具类
 *@author caijing
 *@date 2022/4/8 17:02
 */
import { Router } from 'vue-router';

export class RouterUtil {

  // 打开开发与帮助中心
  static openDoc(router: Router) {
    router.push('/website/doc#fastStart').then();
  }

  // 打开开发与帮助中心的用户授权模块
  static openDocUser(router: Router) {
    router.push('/website/doc#authorization').then();
  }

  // 打开开发与帮助中心的QA模块
  static openDocQA(router: Router) {
    router.push('/website/doc#qa').then();
  }
}
